import axios from 'axios';
import _omit from 'lodash/omit';

import { createEntityDescriptor } from '../../redux/entity-descriptor';

function createAddress(address) {
  return axios.post('/api/addresses.json', _omit(address, ['id', 'owner'])).then(response => response.data);
}

function updateAddress(id, address) {
  return axios.put(`/api/addresses/${id}.json`, _omit(address, ['id', 'owner'])).then(response => response.data);
}

function preProcess(entity) {
  const addresses = (entity.addresses || []).filter(address => !address.id || address.__origin);
  const unmodifiedAddresses = (entity.addresses || []).filter(address => address.id && !address.__origin);
  return Promise.all(
    addresses.map(address => {
      if (address.__origin) {
        const { id, __origin, ...data } = address;
        return updateAddress(address.id, data);
      }
      return createAddress(address);
    })
  ).then(results => ({ ...entity, addresses: [...unmodifiedAddresses, ...results] }));
}

const addresses = createEntityDescriptor('addresses', {
  list: {
    url: '/api/addresses.json',
  },
  create: {
    url: '/api/addresses.json',
  },
  update: {
    url: '/api/addresses/${entity.id}.json',
  },
  delete: {
    url: '/api/addresses/${entity.id}.json',
  },
});

const contacts = createEntityDescriptor('contacts', {
  list: {
    url: '/api/contacts.json',
  },
  create: {
    url: '/api/contacts.json',
    preProcess,
  },
  update: {
    url: '/api/contacts/${entity.id}.json',
    preProcess,
  },
  delete: {
    url: '/api/contacts/${entity.id}.json',
  },
});

const defaultClient = createEntityDescriptor('defaultClient', {
  data: {
    url: '/api/clients/parent.json',
  },
});

export default {
  contacts,
  addresses,
  defaultClient,
};
